import { BookOpen, Code2, File as FileIcon, FileText, HelpCircle, Package, Presentation, Video } from "lucide-react";

/**
 * The kinds of learning resource a Smart Learning session (or a syllabus
 * topic) can carry — SmartSession.resources[].kind / CourseTopicResource.kind.
 *
 *   document        a BatchMaterial (video, PDF, slides, a document)
 *   assignment      a GeneralAssignment — belongs to ONE batch
 *   quiz            an Assessment
 *   codingChallenge a coding Question (picked, never created here)
 *   scorm           a SCORM package (a Lesson) — added through "Document"
 */
export const KIND_META = {
  document: { Icon: BookOpen, label: "Document", plural: "documents", create: "upload", createLabel: "Upload new" },
  assignment: { Icon: FileText, label: "Assignment", plural: "assignments", create: "assignment", createLabel: "Create new" },
  quiz: { Icon: HelpCircle, label: "Quiz", plural: "quizzes", create: "quiz", createLabel: "Create new" },
  codingChallenge: { Icon: Code2, label: "Coding challenge", plural: "coding challenges", create: null, createLabel: null },
};

/** The kinds an admin can add, in the order the "Add" buttons show them. */
export const ADDABLE_KINDS = ["document", "assignment", "quiz", "codingChallenge"];

/** A document's content type, chosen when it is uploaded. */
export const CONTENT_TYPES = [
  { key: "video", label: "Video", Icon: Video, accept: "video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov", maxMB: 2048, hint: "MP4, WebM or MOV" },
  { key: "pdf", label: "PDF", Icon: FileText, accept: "application/pdf,.pdf", maxMB: 100, hint: "A .pdf file" },
  { key: "ppt", label: "Slides", Icon: Presentation, accept: ".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation", maxMB: 200, hint: "A .ppt or .pptx file" },
  { key: "docx", label: "Document", Icon: FileIcon, accept: ".doc,.docx,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain", maxMB: 100, hint: "A Word or text document" },
  { key: "scorm", label: "SCORM", Icon: Package, accept: ".zip,application/zip,application/x-zip-compressed", maxMB: 500, hint: "A SCORM .zip package — plays in the app" },
];

const CONTENT_LABEL = { video: "Video", pdf: "PDF", ppt: "Slides", docx: "Document" };

/** Icon and label for an attached resource's row. */
export function resourceRowMeta(r) {
  if (r?.kind === "scorm") return { Icon: Package, label: "SCORM" };
  const base = KIND_META[r?.kind];
  if (r?.kind === "document" && CONTENT_LABEL[r.contentType]) {
    return { Icon: CONTENT_TYPES.find((c) => c.key === r.contentType)?.Icon || BookOpen, label: CONTENT_LABEL[r.contentType] };
  }
  return { Icon: base?.Icon || FileText, label: base?.label || r?.kind || "Resource" };
}

/** Full editors for the kinds that have one. */
export const FULL_EDITOR_HREF = {
  quiz: (refId) => `/assessments/edit/${refId}`,
  assignment: (refId) => `/batch-assignments/edit/${refId}`,
};
